import {Component, OnInit} from '@angular/core';
import {LoanApplicationService} from '../loan-application.service';
import {BranchDBService} from '../../../@db/branch-db.service';

@Component({
  selector: 'bb-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.scss'],
})
export class BranchesComponent implements OnInit {
  branches = this.branchDb.list
    .filter(b => b.is_lead_choice)
    .toArray()
    .map(
      value => value.sort(function (a, b) {
        return a.sequence - b.sequence;
      }));

  constructor(public loan: LoanApplicationService,
              public branchDb: BranchDBService) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  ngOnInit() {
  }
}
